import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import Container from '@mui/material/Container';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import HomeIcon from '@mui/icons-material/Home';
import { useHistory } from 'react-router';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import GestureIcon from '@mui/icons-material/Gesture';
import BrushIcon from '@mui/icons-material/Brush';
import EmailIcon from '@mui/icons-material/Email';
import logo from '../assets/logo.png';

export default function ButtonAppBar() {
  const [menuOpen, setMenuOpen] = React.useState(false);
  const history = useHistory();

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
      role='presentation'
      onClick={() => setMenuOpen(false)}
      onKeyDown={() => setMenuOpen(false)}
    >
      <List>
        <ListItem
          button
          key='home'
          onClick={() => {
            history.push('/');
          }}
        >
          <ListItemIcon>
            <HomeIcon />
          </ListItemIcon>
          <ListItemText primary='Home' />
        </ListItem>
        <ListItem
          button
          onClick={() => {
            history.push('/for-sale');
          }}
        >
          <ListItemIcon>
            <LoyaltyIcon />
          </ListItemIcon>
          <ListItemText primary='For Sale' />
        </ListItem>
        <ListItem
          button
          onClick={() => {
            history.push('/custom');
          }}
        >
          <ListItemIcon>
            <GestureIcon />
          </ListItemIcon>
          <ListItemText primary='Custom Orders' />
        </ListItem>
        <ListItem
          button
          onClick={() => {
            history.push('/gallery');
          }}
        >
          <ListItemIcon>
            <BrushIcon />
          </ListItemIcon>
          <ListItemText primary='Gallery' />
        </ListItem>
        <ListItem
          button
          onClick={() => {
            history.push('/about');
          }}
        >
          <ListItemIcon>
            <BrushIcon />
          </ListItemIcon>
          <ListItemText primary='About Me' />
        </ListItem>
        <ListItem
          button
          key='Contact'
          onClick={() => {
            history.push('/contact');
          }}
        >
          <ListItemIcon>
            <EmailIcon />
          </ListItemIcon>
          <ListItemText primary='Contact' />
        </ListItem>
        {/*<Divider />
        <ListItem>
          <ListItemText primary='*** ADMIN ***' />
        </ListItem>
        <ListItem
          button
          key='admin'
          onClick={() => {
            history.push('/admin/shop');
          }}
        >
          <ListItemIcon>
            <AccountCircleIcon />
          </ListItemIcon>
          <ListItemText primary='SHOP' />
        </ListItem>
        <ListItem
          button
          key='admin'
          onClick={() => {
            history.push('/admin/orders');
          }}
        >
          <ListItemIcon>
            <AccountCircleIcon />
          </ListItemIcon>
          <ListItemText primary='ORDERS' />
        </ListItem> */}
      </List>
    </Box>
  );
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position='static'>
        <Toolbar>
          <IconButton
            size='large'
            edge='start'
            aria-label='menu'
            sx={{ mr: 2, display: { sm: 'none' } }}
            onClick={() => setMenuOpen(true)}
          >
            <MenuIcon color='default' sx={{ sm: { display: 'none' } }} />
          </IconButton>
          <Typography
            component='h3'
            variant='primary'
            color='default'
            sx={{ flexGrow: 1, ml: 1, zIndex: 600 }}
          >
            Shey's Craft Room
          </Typography>
          <Typography
            component='h3'
            variant='primary'
            color='default'
            sx={{
              flexGrow: 2,
              fontSize: 25,
              zIndex: 2000,
              cursor: 'pointer',
              display: { xs: 'none', md: 'block' },
            }}
            onClick={() => history.push('/')}
          >
            Home
          </Typography>
          <Typography
            component='h3'
            variant='primary'
            color='default'
            sx={{
              flexGrow: 2,
              fontSize: 25,
              zIndex: 2000,
              cursor: 'pointer',
              display: { xs: 'none', md: 'block' },
            }}
            onClick={() => history.push('/gallery')}
          >
            Gallery
          </Typography>
          <Typography
            component='h3'
            variant='primary'
            color='default'
            sx={{
              flexGrow: 2,
              fontSize: 25,
              zIndex: 2000,
              cursor: 'pointer',
              display: { xs: 'none', md: 'block' },
            }}
            onClick={() => history.push('/for-sale')}
          >
            For Sale
          </Typography>
          <Typography
            component='h3'
            variant='primary'
            color='default'
            sx={{
              flexGrow: 2,
              fontSize: 25,
              zIndex: 2000,
              cursor: 'pointer',
              display: { xs: 'none', md: 'block' },
            }}
            onClick={() => history.push('/custom')}
          >
            Custom Orders
          </Typography>
          <Typography
            component='h3'
            variant='primary'
            color='default'
            sx={{
              flexGrow: 2,
              fontSize: 25,
              zIndex: 2000,
              cursor: 'pointer',
              display: { xs: 'none', md: 'block' },
            }}
            onClick={() => history.push('/about')}
          >
            About Me
          </Typography>
          <Typography
            component='h3'
            variant='primary'
            color='default'
            component='h3'
            sx={{
              flexGrow: 2,
              fontSize: 25,
              zIndex: 2000,
              cursor: 'pointer',
              display: { xs: 'none', md: 'block' },
            }}
            onClick={() => history.push('/contact')}
          >
            Contact
          </Typography>
          {/* <Typography
            component='h3'
            variant='primary'
            color='default'
            component='h3'
            sx={{
              flexGrow: 2,
              fontSize: 25,
              zIndex: 2000,
              cursor: 'pointer',
              display: { xs: 'none', md: 'block' },
            }}
            onClick={() => history.push('/admin/orders')}
          >
            Ad Orders
          </Typography>
          <Typography
            component='h3'
            variant='primary'
            color='default'
            component='h3'
            sx={{
              flexGrow: 2,
              fontSize: 25,
              zIndex: 2000,
              cursor: 'pointer',
              display: { xs: 'none', md: 'block' },
            }}
            onClick={() => history.push('/admin/shop')}
          >
            Ad Shop
          </Typography> */}
          <img
            src={logo}
            alt={'logo'}
            width={50}
            style={{
              // position: 'absolute',
              // marginTop: 120,
              // left: '5%',
              marginLeft: '-50px !important',
              display: 'block',
              zIndex: 500,
            }}
          />
        </Toolbar>
      </AppBar>
      <Drawer anchor='left' open={menuOpen} onClose={() => setMenuOpen(false)}>
        {list('left')}
      </Drawer>
    </Box>
  );
}

{
  /* <ListItem
button
key='Profile'
onClick={() => {
  history.push('/account');
}}
>
<ListItemIcon>
  <AccountCircleIcon />
</ListItemIcon>
<ListItemText primary='My Account' />
</ListItem> */
}
